import { render, staticRenderFns } from "./TinhamosCard.vue?vue&type=template&id=a638d92e"
import script from "./TinhamosCard.vue?vue&type=script&lang=ts"
export * from "./TinhamosCard.vue?vue&type=script&lang=ts"
import style0 from "./TinhamosCard.vue?vue&type=style&index=0&id=a638d92e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports